import { customFetch } from '#/services/customFetch'
import type {
  Course,
  CourseListParams,
  PaginatedResponse,
} from '../types/course.types'

export async function getCourses(
  params: CourseListParams = {},
): Promise<PaginatedResponse<Course>> {
  const query = new URLSearchParams()
  if (params.page) query.set('page', params.page.toString())
  if (params.limit) query.set('limit', params.limit.toString())
  if (params.categoryId) query.set('categoryId', params.categoryId)
  if (params.categorySlug) query.set('categorySlug', params.categorySlug)
  if (params.tags) query.set('tags', params.tags)
  if (params.search) query.set('search', params.search)

  const queryString = query.toString()
  const endpoint = `/student/courses${queryString ? `?${queryString}` : ''}`

  return customFetch<PaginatedResponse<Course>>(endpoint)
}
